<template>
  <section class="box box--small-padding">
    <FetchJson :url="url">
      <template #default="{ json, loading }">
        <h2 class="box__header title-24">Общие показатели по услугам</h2>
        <div class="layout--horizontal" v-if="!loading">
          <ScalarIndicator
            title="Всего предоставлено"
            :loading="loading"
            :value="json.completedCount"
          ></ScalarIndicator>
          <ScalarIndicator
            title="Из них выдано отказов"
            :loading="loading"
            :value="json.rejectedCount"
          ></ScalarIndicator>
          <ScalarIndicator
            title="Среднее время оказания, дней"
            :loading="loading"
            :value="json.averageDuration"
          ></ScalarIndicator>
          <ScalarIndicator
            title="В процессе предоставления"
            :loading="loading"
            :value="json.inProcessCount"
          ></ScalarIndicator>
        </div>
      </template>
    </FetchJson>
  </section>
</template>

<script>
import { computed, toRefs } from "vue";
import { dateToString } from "@/modules/date";
import ScalarIndicator from "@/components/infoblocks/ScalarIndicator";

export default {
  props: {
    filter: {
      type: Object,
      required: true,
    },
  },
  components: {
    ScalarIndicator,
  },
  setup(props) {
    const filter = toRefs(props.filter);
    const url = computed(
      () =>
        `services/service-general-indicator?from=${dateToString(
          filter.from.value
        )}&to=${dateToString(filter.to.value)}&territory=${
          filter.territory.value.alias || ""
        }&serviceType=${filter.serviceType.value.alias || ""}`
    );

    return {
      url,
    };
  },
};
</script>

<style lang="scss">
.indicators.layout--horizontal {
  align-items: stretch;
}
</style>
